import script from "./FoilPeelTable.vue?vue&type=script&setup=true&lang=js"
export * from "./FoilPeelTable.vue?vue&type=script&setup=true&lang=js"

import "./FoilPeelTable.vue?vue&type=style&index=0&id=aaa9047c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aaa9047c"]])

export default __exports__